import React from 'react';
import classNames from 'classnames';
import styles from './style.module.scss';

const Loader = ({ spinning = true, transparent, fullScreen }) => (
  <div
    className={classNames(styles.loader, {
      [styles.hidden]: !spinning,
      [styles.fullScreen]: fullScreen,
      [styles.transparent]: transparent,
    })}
  />
);

export default Loader
